import { Row, Col, Form } from "react-bootstrap";

const CustomerSelection = ({ customers, selectedCustomers, setSelectedCustomers }) => {
    return (
        <Row className='mb-3'>
            <Col sm={12}>
                <Form.Group className='form-group'>
                    <Form.Label>
                        For Customers{' '}
                        <span style={{ fontSize: '12px', fontWeight: 'normal', color: '#6c757d' }}>
                            ({selectedCustomers.length} of {customers.length} selected)
                        </span>
                    </Form.Label>
                    <div
                        className="checkbox-group"
                        style={{
                            maxHeight: '200px',
                            overflowY: 'auto',
                            padding: '8px 0',
                            border: '1px solid #dee2e6',
                            borderRadius: '4px'
                        }}
                    >
                        {customers.length > 0 ? (
                            customers.map((customer) => (
                                <div
                                    key={customer.CustomerID}
                                    className="form-check"
                                    style={{
                                        padding: '6px 8px',
                                        fontSize: '14px',
                                        minHeight: 'auto'
                                    }}
                                >
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`customer-${customer.CustomerID}`}
                                        checked={selectedCustomers.includes(customer.CustomerID)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setSelectedCustomers([...selectedCustomers, customer.CustomerID]);
                                            } else {
                                                setSelectedCustomers(selectedCustomers.filter(id => id !== customer.CustomerID));
                                            }
                                        }}
                                        style={{
                                            width: '14px',
                                            height: '14px',
                                            marginRight: '8px'
                                        }}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor={`customer-${customer.CustomerID}`}
                                        style={{
                                            fontSize: '13px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        {customer.CustomerName}{customer.email ? ` (${customer.email})` : ''}
                                    </label>
                                </div>
                            ))
                        ) : (
                            <p className="text-muted mb-0 px-2">No customers available</p>
                        )}
                    </div>

                </Form.Group>
            </Col>
        </Row>
    );
};

export default CustomerSelection;

